import React from 'react';
import { Box, Typography } from '@mui/material';

import DateTimeText from '../../../DateTimeText';
import RenderIf from '../../../../renderIf/RenderIf';

import useStyles from './styles';

//TODO #TechnicalDebt - Get these statuses from the database.
const statuses = [
    { label: 'Started', id: 1, hex: 'submitted' },
    { label: 'Submitted', id: 2, hex: 'submitted' },
    { label: 'Approved', id: 6, hex: 'approved' },
    { label: 'Returned', id: 3, hex: 'warning' },
];

const Status = ({ statusId, lastUpdated, displayLastUpdated = true, size = 'medium', styleOverride = {} }) => {
    let displayedStatus;
    //TODO #TechnicalDebt - Remove the ability to control the color and text of this component via integer status prop.
    if (Number.isInteger(statusId)) displayedStatus = statuses.find((obj) => obj.id === statusId);
    else if (
        statusId instanceof Object &&
        Number.isInteger(statusId?.id) &&
        typeof statusId?.description === 'string' &&
        typeof statusId?.displayColor === 'string'
    ) {
        displayedStatus = {
            label: statusId.description,
            hex: statusId.displayColor,
        };
    }

    const classes = useStyles({ size: size, backgroundColor: displayedStatus.hex, ...styleOverride });

    return (
        <Box>
            <Box>
                <Box
                    component="span"
                    className={classes.circleDisplay}
                />{' '}
                <Typography className={classes.textDisplay}>{displayedStatus.label}</Typography>
            </Box>

            <RenderIf isTrue={displayLastUpdated}>
                <Typography
                    component="div"
                    sx={{
                        fontSize: '12px',
                    }}
                >
                    Updated on{' '}
                    <DateTimeText
                        className={classes.dateTime}
                        type="short"
                        date={lastUpdated ? lastUpdated : new Date()}
                    />
                </Typography>
            </RenderIf>
        </Box>
    );
};

//TODO #TechnicalDebt - Description is not localized and will need to be.

export default Status;
